export const HKD_SYMBOL = 'HKD';

export function isHkdCurrency(currency?: string | null): boolean {
    const normalized = (currency || '').trim().toUpperCase();
    return normalized === 'HKD' || normalized === 'HK$';
}

export function deriveExchangeRate(
    assessableValue?: number | null,
    assessmentValue?: number | null,
): number {
    if (assessableValue == null || assessmentValue == null || assessmentValue === 0) {
        return 1;
    }
    return Math.abs(assessableValue / assessmentValue);
}

export function toHkdAmount(amount: number, exchangeRate: number): number {
    if (!exchangeRate || exchangeRate === 1) {
        return amount;
    }
    return amount * exchangeRate;
}

export function toPresentationAmount(hkdAmount: number, exchangeRate: number): number {
    if (!exchangeRate || exchangeRate === 1) {
        return hkdAmount;
    }
    return hkdAmount / exchangeRate;
}

/** Strip trailing zeros from exchange rate in assessable name, e.g. @7.800000 -> @7.8 */
export function formatAssessableName(name?: string | null): string {
    if (!name) {
        return '';
    }
    return name.replace(/@([\d.]+)/, (_, rate: string) => {
        const parsed = Number(rate);
        if (!Number.isFinite(parsed)) {
            return `@${rate}`;
        }
        return `@${parseFloat(parsed.toFixed(1))}`;
    });
}
